// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"62919c07","834":"658a72c3"}[chunkId] + ".chunk.js";
};